import { SET_EDITOR_SELECTED_NODE } from 'client/constants/actions';

/**
 * @param payload {Object|Array} Single or multiple selected node
 * @param payload.type {String}
 * @param payload.data {Object}
 * @param payload.data.id {String}
 * @returns {function(dispatch, getState): CurrentSelection}
 */
export function setEditorSelectedNode(payload) {
	return async (dispatch, getState) => {
		await dispatch({ type: SET_EDITOR_SELECTED_NODE, payload });
		return getState().editor.selection;
	};
}

/**
 * @typedef CurrentSelection
 * @property {Object} props
 * @property {Object<SelectedBlockInfo>} props.clicked - clicked blocks props
 * @property {Object<SelectedBlockInfo>} props.hovered - hovered blocks props
 */

/**
 * @typedef SelectedBlockInfo
 * @property {Object} editableModeProps
 * @property {String} _id - bb id
 * @property {String} id - bb DOM node id
 * @property {String<'outer', 'inner'>} selectionStage
 * @property {Object} symbol
 * @property {Object} type
 * @property {Object} uiConfig
 */
